import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const key = (slug) => `wua-guide-progress:${slug}`;
const readLocal = (slug) => { try { return JSON.parse(localStorage.getItem(key(slug))) || []; } catch { return []; } };
const writeLocal = (slug, ids) => { try { ids ? localStorage.setItem(key(slug), JSON.stringify(ids)) : localStorage.removeItem(key(slug)); } catch { /* storage blocked */ } };

// Finished sections: saved to the account when signed in (device progress is merged in once), else kept on this device.
export function useGuideProgress(slug) {
  const { user, loading } = useAuth();
  const [done, setDone] = useState(() => new Set());
  useEffect(() => {
    if (loading) return;
    if (!user) { setDone(new Set(readLocal(slug))); return; }
    let live = true;
    const local = readLocal(slug);
    const req = local.length ? api.post(`/sci/guide-progress/${slug}`, { done: local }) : api.get(`/sci/guide-progress/${slug}`);
    req.then((r) => { if (local.length) writeLocal(slug, null); if (live) setDone(new Set(r.data.done)); }).catch(() => {});
    return () => { live = false; };
  }, [slug, user, loading]);
  const finish = useCallback((id) => {
    setDone((p) => {
      if (p.has(id)) return p;
      const n = new Set(p).add(id);
      if (!user) writeLocal(slug, [...n]);
      return n;
    });
    if (user) api.post(`/sci/guide-progress/${slug}`, { done: [id] }).catch(() => {});
  }, [slug, user]);
  return { done, finish };
}
